import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { GraphemeMorphemePanelsContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";

/** `used in 自個兒|自个儿[zi4 ge3 r5]` → `used in 自个儿`: a tab label has no room for CEDICT markup. */
function simplifyCedictReferences(definition: string): string {
  return definition
    .replaceAll(/[^\s|[\]]+\|([^\s|[\]]+)/g, "$1")
    .replaceAll(/\[[^\]]*\]/g, "")
    .trim();
}

/** Each Browse reading tab's caption and its VoiceOver label. */
export function useBrowseMnemonicTabLabels(
  screens: readonly { title: string }[],
  readings: readonly (string | undefined)[],
) {
  const [pinyinList, definitionList] = useContextSelectors(
    GraphemeMorphemePanelsContext,
    (c) => c.readonlySlice.data.pinyinList,
    (c) => c.readonlySlice.data.definitionList,
  );
  // The pinyin is the reading tab's icon, so its label is that reading's own gloss. A reading
  // without a pronunciation card (个 gě) falls back to its first dictionary definition.
  const labels = screens.map((screen, index) => {
    const pinyin = readings[index];
    if (pinyin === undefined) {
      return screen.title;
    }
    const gloss = pinyinList.find((entry) => entry.toneNumbersPinyin === pinyin)?.gloss?.trim();
    if (gloss) {
      return gloss;
    }
    const definition = definitionList.find((entry) => entry.pinyin === pinyin)?.entries[0];
    return definition === undefined ? "" : simplifyCedictReferences(definition);
  });
  const accessibilityLabels = screens.map((screen, index) =>
    readings[index] === undefined || labels[index] === ""
      ? screen.title
      : `${screen.title}, ${labels[index]}`,
  );
  return { accessibilityLabels, labels };
}
